// InsureDocs 5.39.0 — text-message helpers for the HealthSherpa "Text link to client" message (Henry 2026-11-01).
// Mirrors the server (services/healthsherpa/config.sms_septets / sms_segments / enroll_sms_text): GSM-7 only,
// extension characters ^ { } \ [ ] ~ | count twice, the backtick (and anything outside plain ASCII) can't be sent as
// GSM-7. 1 segment up to 160, then 153 per segment. The server re-checks everything; this is for display.
//   node test: cd /tmp && node --experimental-default-type=module /opt/insuredocs/frontend/src/hsSms.test.mjs

const BASIC = new Set('@$\n\r !"#%&\'()*+,-./0123456789:;<=>?ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz');
const EXT = new Set('^{}\\[]~|');

export function smsSeptets(text) {
  let n = 0;
  for (const ch of String(text || '')) {
    if (BASIC.has(ch)) n += 1;
    else if (EXT.has(ch)) n += 2;
    else return null;
  }
  return n;
}

export function smsSegments(text) {
  const n = smsSeptets(text);
  if (n === null) return null;
  return n <= 160 ? 1 : Math.ceil(n / 153);
}

export function smsText(template, year, link) {
  return String(template || '').split('<year>').join(String(year)).split('<link>').join(String(link));
}

// A problem with the template, or null when it is fine (same rules as the server's validate_setting).
export function templateProblem(t) {
  const s = String(t || '');
  if (!s.trim()) return "The message can't be empty";
  if (s.length > 320) return 'At most 320 characters';
  if ([...s].some((ch) => ch.charCodeAt(0) > 126)) return 'Plain ASCII only (no curly quotes, dashes or accents)';
  if ([...s].some((ch) => ch.charCodeAt(0) < 32)) return 'No line breaks or control characters';
  if (smsSeptets(s) === null) return "The ` character can't be sent in a normal text message";
  if (s.split('<link>').length !== 2) return 'Must contain <link> exactly once';
  return null;
}

// Link length used for the Settings estimate (the real count is shown when a text is sent).
export const LINK_ESTIMATE = 120;
